import React, {Component} from 'react';
import {connect} from 'react-redux';

import {ButtonSuccess, ButtonDanger, LinkInfo, ButtonPrimary, ButtonDefault} from 'components/buttons';

import {Actions} from 'components/actions';
import {changeDocumentStatus} from 'redux/actions/admin/documents';

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({
  onChange: (id) => dispatch(changeDocumentStatus(id))
})

class ActionsList extends Component {

  render() {
    return (
      <Actions> 

        {!(this.props.document.get('current_status') === "public"
         || this.props.document.get('current_status') === "archive"
         || this.props.document.get('current_status') === "service") &&
        <li>
         <ButtonSuccess value="Оприлюднити" onClick={(event, id) => {
           this.props.changeValue('public', 'current_status');
           this.props.onChange(this.props.id);
         }} />
        </li>
        }

        {!(this.props.document.get('current_status') === "public"
          || this.props.document.get('current_status') === "service") &&
          <li>
            <ButtonDanger onClick={this.props.toggleModal} value="Видалити" />
          </li>
        }

        {!(this.props.document.get('current_status') === "public"
        || this.props.document.get('current_status') === "archive"
        || this.props.document.get('current_status') === "service") &&
        <li>
          <LinkInfo to={`/admin/documents/detail/${this.props.id}/edit`}>Редагувати</LinkInfo>
        </li>
        }

        {!(this.props.document.get('current_status') === "public"
          || this.props.document.get('current_status') === "service") &&
          <li>
            <ButtonPrimary value="Зробити cлужбовим" onClick={(event) => {
              this.props.changeValue('service', 'current_status')
              this.props.onChange(this.props.id)
            }} />
          </li>
        }

        {!(this.props.document.get('current_status') === "archive"
         || this.props.document.get('current_status') === "draft" )
          &&
        <li>
          <ButtonDefault value="В архів" onClick={(event) => {
            this.props.changeValue('archive', 'current_status');
            this.props.onChange(this.props.id);
          }} />
        </li>
        }

        {!(this.props.document.get('current_status') === "draft") &&
          <li>
            <LinkInfo to={`/admin/mailing/create/${this.props.id}`}>Створити розсилку</LinkInfo>
          </li>
        }

      </Actions>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ActionsList);



// WEBPACK FOOTER //
// ./src/admin/documents/detail/actions-list.js